// -- == //
import React from 'react';
import { Formik } from 'formik';

import PrimaryButton from 'components/form/buttons/primaryButton';
import OutlineButton from 'components/form/buttons/outLineButton';
import TextIput from 'components/form/textInput';
import { useActions } from 'common/hooks/useActions';
import TextArea from 'components/form/texArea';

import * as S from '../../styles';
import { useNavigate } from 'react-router-dom';
import { ValidationCreateSendToAllNotif } from 'common/validations';

interface IProps {
  data?: any;
}

const NotificationCreateSendToAllForm: React.FC<IProps> = ({ data }) => {
  const { notficationCreateCustomRequestAction } = useActions();

  const nav = useNavigate();

  return (
    <Formik
      initialValues={{
        title: data?.title || '',
        body: data?.body || '',
        sendToAll: true
      }}
      enableReinitialize
      validationSchema={ValidationCreateSendToAllNotif}
      onSubmit={(values, { setSubmitting }) => {
        notficationCreateCustomRequestAction(values, () => {
          nav('/panel/notifications');
        });
        setSubmitting(false);
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
        <>
          <S.Body>
            <S.Grid2>
              <S.Rows>
                <TextIput
                  type="text"
                  name="title"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Notification title"
                  label="Title"
                  required
                  value={values.title}
                  message={touched.title && (errors.title as any)}
                  error={touched.title && (errors.title as unknown as boolean)}
                />

                <TextArea
                  label="Message"
                  required
                  name="body"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="What should people see?"
                  value={values.body}
                  message={touched.body && (errors.body as any)}
                  error={touched.body && (errors.body as unknown as boolean)}
                  help="Sent as a push notification. Keep it under two lines."
                />
              </S.Rows>
            </S.Grid2>
          </S.Body>

          <S.Actions>
            <OutlineButton link="/panel/notifications">Cancel</OutlineButton>
            <PrimaryButton onClick={handleSubmit}>Send notification</PrimaryButton>
          </S.Actions>
        </>
      )}
    </Formik>
  );
};

export default NotificationCreateSendToAllForm;
